// extracted by mini-css-extract-plugin
module.exports = {"cover":"ReleasePage_cover__139km","title":"ReleasePage_title__VaGbj"};